/**
 * 实际控制人模块
 */

import React, { FC, useEffect, useMemo, useState } from 'react';
import { ProDetailList, ProText } from '@bedrock/eed-react';
import { Radio } from '@bedrock/components';
import {
  FormModule,
  FormItemActualControllerDetailList,
  FormItemPersonName,
  FormItemPersonIdType,
  FormItemPersonId,
  FormItemShareholdingRatio,
  FormItemDataSource,
} from '@purchase/supplier';

type DataSource = 'supplier' | 'thirdParty';

const ActualControllerModule: FC<{
  formDetail: any;
  isExternal?: boolean;
  isDiff?: boolean;
}> = ({ formDetail, isExternal = false, isDiff = false }) => {
  const [actualControllerSource, setActualControllerSource] =
    useState<DataSource>('supplier');

  const supplierActualControllerCount = useMemo(
    () => formDetail?.vendorActualControllerInfos?.length ?? 0,
    [formDetail]
  );
  const qccActualControllerCount = useMemo(
    () => formDetail?.vendorQccActualControllerInfos?.length ?? 0,
    [formDetail]
  );
  const totalActualControllerCount =
    supplierActualControllerCount + qccActualControllerCount;

  // 当只有一方有数据时，自动切换到对应的数据源
  useEffect(() => {
    if (supplierActualControllerCount > 0 && qccActualControllerCount === 0) {
      setActualControllerSource('supplier');
    } else if (
      supplierActualControllerCount === 0 &&
      qccActualControllerCount > 0
    ) {
      setActualControllerSource('thirdParty');
    }
  }, [supplierActualControllerCount, qccActualControllerCount]);

  return (
    <FormModule
      title="实际控制人"
      titleCount={isDiff ? undefined : totalActualControllerCount}
      proCardProps={{
        expandable: true,
        defaultExpanded: totalActualControllerCount > 0,
      }}
    >
      {!isExternal && (
        <Radio.Group
          value={actualControllerSource}
          onChange={(e) => setActualControllerSource(e.target.value)}
          className="mb-3"
        >
          <Radio.Button value="supplier">
            供应商录入 ({supplierActualControllerCount})
          </Radio.Button>
          <Radio.Button value="thirdParty">
            第三方获取 ({qccActualControllerCount})
          </Radio.Button>
        </Radio.Group>
      )}

      {actualControllerSource === 'supplier' && (
        <FormItemActualControllerDetailList
          name="vendorActualControllerInfos"
          fieldProps={{ scroll: { x: 1120 } }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(value, record, index) => index + 1}
          </ProDetailList.Item>
          <FormItemPersonName
            label="姓名"
            name="name"
            meta={{
              columnProps: { width: 200, className: 'font-bold', fixed: true },
            }}
          />
          <FormItemPersonIdType label="证件类型" name="personIdType" />
          <FormItemPersonId label="证件号码" name="personId" />
        </FormItemActualControllerDetailList>
      )}

      {actualControllerSource === 'thirdParty' && (
        <FormItemActualControllerDetailList
          name="vendorQccActualControllerInfos"
          fieldProps={{ scroll: { x: 1120 } }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(value, record, index) => index + 1}
          </ProDetailList.Item>
          <FormItemPersonName
            label="姓名"
            name="name"
            meta={{
              columnProps: { width: 200, className: 'font-bold', fixed: true },
            }}
          />
          <FormItemShareholdingRatio label="股权比例" name="percent" />
          <FormItemShareholdingRatio label="最终受益股份" name="percentTotal" />
          <FormItemShareholdingRatio label="表决权比例" name="controlPercent" />
          <ProDetailList.Item label="更新时间" name="updateTime">
            <ProText />
          </ProDetailList.Item>
          <FormItemDataSource
            label="数据来源"
            name="dataSource"
            meta={{ columnProps: { width: 160 } }}
          />
        </FormItemActualControllerDetailList>
      )}
    </FormModule>
  );
};

export default ActualControllerModule;
